import { useEffect, useState } from "react";
import { Clock as ClockIcon } from "lucide-react";

export default function Clock() {
  const [now, setNow] = useState(new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  const time = now.toLocaleTimeString("ar-SA-u-nu-latn", { hour: "2-digit", minute: "2-digit", second: "2-digit" });
  const dateStr = now.toLocaleDateString("ar-SA-u-ca-gregory-nu-latn", {
    weekday: "long", year: "numeric", month: "long", day: "numeric",
  });
  return (
    <div className="flex items-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-2.5 shadow-sm" data-testid="dashboard-clock">
      <ClockIcon className="h-5 w-5 text-emerald-700" />
      <span className="font-mono text-lg font-bold text-slate-800" dir="ltr">{time}</span>
      <span className="hidden text-sm text-slate-400 sm:inline">— {dateStr}</span>
    </div>
  );
}
